import React from 'react'
import i18n from 'i18n-js'
import { withRouter } from 'react-router-dom'
import { ImCross } from 'react-icons/im'

import SidebarLanguage from './SidebarLanguage/SidebarLanguage'

import './Sidebar.scss'

const Sidebar = props => {
    // console.log('sidebar', props)
    const overlayClasses = ['Sidebar', props.active ? 'active' : '']

    const onChangeRoute = (evt, route) => {
        evt.preventDefault()
        props.close()
        props.history.push(route)
    }

    return <aside className={overlayClasses.join(' ')} role="dialog" aria-label={i18n.t('sidebar')}>
        <div className="dialog-content">
            <button type="button" className="close-overlay" aria-label={i18n.t('close_sidebar')} onClick={() => props.close()}>
                <ImCross size="1.5em" />
            </button>
            <div className="container">
                <h2 className="pt-5 mb-5">{i18n.t('sidebar_title')}</h2>
                <nav aria-label={i18n.t('sidebar_links')}>
                    <a href="/" onClick={evt => onChangeRoute(evt, '/')}>{i18n.t('sidebar_link_homepage')}</a>
                    {/* <a href="/ehp" onClick={evt => onChangeRoute(evt, '/ehp')}>EHPCalculator</a> */}
                    <a href="/bj5" onClick={evt => onChangeRoute(evt, '/bj5')}>{i18n.t('sidebar_link_bj5')}</a>
                    <a href="/credits" onClick={evt => onChangeRoute(evt, '/credits')}>{i18n.t('sidebar_link_credits')}</a>
                </nav>
                <SidebarLanguage />
            </div>
        </div>
    </aside>
}

export default withRouter(Sidebar)